import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const BlogCardSkeleton: React.FC = () => {
  return (
    <div className="card elev-sm" style={{ padding: 0, overflow: 'hidden' }}>
      <div className="relative" style={{ aspectRatio: '16 / 10' }}>
        <Skeleton height="100%" style={{ position: 'absolute', inset: 0 }} />
      </div>

      <div style={{ padding: 'var(--space-4)' }}>
        <Skeleton height={18} width="80%" style={{ marginBottom: 'var(--space-2)' }} />
        <Skeleton count={2} style={{ marginBottom: 'var(--space-3)' }} />
        <Skeleton width={70} height={14} />
      </div>
    </div>
  );
};

export default BlogCardSkeleton;
